export default "__VITE_ASSET__G87Fyrzw__"